<script lang="ts">
	import type { MenuItem } from "../../../../core/schema/MenuItem.js";
	import Menu from "./Menu.svelte";

	export let pageSlug: string;
	export let menu: MenuItem[];
	let className = "";
	export { className as class };
</script>

<nav class="hidden w-fit xl:block xl:self-stretch {className}">
	<Menu desktop {pageSlug} {menu} />
</nav>
